var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"neko-bottom-toolbar"},[_c('v-card-actions',{attrs:{"align-end":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }